import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var ProductUpdatesOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M10 1.6665C9.31004 1.6665 8.75004 2.2265 8.75004 2.9165V3.49919C6.60038 4.05839 5.00004 6.01405 5.00004 8.33317V12.3647L4.39945 14.1665H3.33337V15.8332H8.55798C8.41124 16.0864 8.33377 16.3738 8.33337 16.6665C8.33337 17.1085 8.50897 17.5325 8.82153 17.845C9.13409 18.1576 9.55801 18.3332 10 18.3332C10.4421 18.3332 10.866 18.1576 11.1786 17.845C11.4911 17.5325 11.6667 17.1085 11.6667 16.6665C11.6658 16.3737 11.5878 16.0863 11.4405 15.8332H16.6667V14.1665H15.6006L15 12.3647V8.33317C15 6.01405 13.3997 4.05839 11.25 3.49919V2.9165C11.25 2.2265 10.69 1.6665 10 1.6665ZM10 4.99984C11.8504 4.99984 13.3334 6.48286 13.3334 8.33317V12.6349L13.8428 14.1665H6.15727L6.66671 12.6349V8.33317C6.66671 6.48286 8.14973 4.99984 10 4.99984Z",
    fill: fill
  }));
};
export { ProductUpdatesOutline as default };
//# sourceMappingURL=ProductUpdatesOutline.js.map
